import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { AvatarImageWithClientIds } from "~/modules/image/api/avatarImage/avatarImageTypes.ts";

export function indexCompanyAvatarImages(): AxiosApiResponsePromise<AvatarImageWithClientIds[]> {
	return axiosApi.get("/companies/avatar-images");
}